import { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    Flex,
    ModalContent,
    ModalFooter,
    Input,
    useToast,
    Button,
} from '@chakra-ui/react';
import ZaraButton from '../custom-components/buttons/Button';
import { useApolloClient, useMutation } from '@apollo/client';
import { ChangeAgentTitle } from '../../graphql/mutations/ChangeAgentTitle';
import { useError } from '../../error-provider/ErrorProvider';

const ChangeTitle = ({ isOpen, onClose, name, agentId }) => {
    const apolloClient = useApolloClient();

    const [value, setValue] = useState(name);
    const { showError } = useError();
    const toast = useToast();

    const [onChangeAgentTitle, { loading }] = useMutation(ChangeAgentTitle, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const changeTitle = () => {
        try {
            onChangeAgentTitle({
                variables: {
                    title: value,
                    agentId: agentId,
                },
                onCompleted(data) {
                    if (data.changeAgentTitle.__typename === 'SuccessType') {
                        toast({
                            title: data.changeAgentTitle.message,
                            status: 'success',
                            isClosable: true,
                        });

                        apolloClient.cache.modify({
                            id: `AgentType:${agentId}`,
                            fields: {
                                title() {
                                    return value;
                                },
                            },
                        });
                    } else {
                        toast({
                            title: data.changeAgentTitle.message,
                            status: 'error',
                            isClosable: true,
                        });
                    }
                },
            });
        } catch (error) {
        } finally {
            onClose();
            setValue('');
        }
    };

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose} motionPreset='slideInBottom'>
            <ModalOverlay />
            <ModalContent minW='448px'>
                <ModalHeader>Change Agent Title</ModalHeader>
                <ModalBody>
                    <Input value={value} onChange={(e) => setValue(e.target.value)} />
                </ModalBody>
                <ModalFooter p='16px 24px'>
                    <Flex alignItems='center' w='100%' justifyContent='space-between'>
                        <Button
                            isDisabled={loading}
                            onClick={() => {
                                onClose();
                                setValue('');
                            }}
                            variant='outline'
                            fontSize='sm'
                        >
                            Back
                        </Button>
                        <ZaraButton isLoading={loading} onClick={changeTitle} variant='blackAlpha'>
                            Save
                        </ZaraButton>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ChangeTitle;
